import { skipToken } from '@tanstack/react-query';
import { callRequest } from '../../helpers/callRequest';
import { autofillParams } from './autofillParams';
import { getQueryKey } from './getQueryKey';
export const getUseWrappedQueryWithAxiosConfig = ({ request, wrapperOptions, getAutofill, getUseQuery, }) => {
    const useQuery = getUseQuery();
    const useWrappedQueryWithAxiosConfig = (params, axiosConfig, queryOptions) => {
        const queryKey = getQueryKey(wrapperOptions, params);
        const getQueryFn = () => {
            if (params === skipToken)
                return skipToken;
            const autofiledParams = autofillParams(params, getAutofill);
            return () => callRequest(request, autofiledParams, axiosConfig);
        };
        return useQuery({
            queryFn: getQueryFn(),
            queryKey,
            ...queryOptions,
        });
    };
    return useWrappedQueryWithAxiosConfig;
};
